<template>
  <div class="header">
    <h1><img src="../../assets/images/logo.png" alt="EnBW ODR" /></h1>
  </div>
</template>

<script>
export default {
  name: "HeaderLogo",
};
</script>
<style lang="scss" scoped>
.header {
  //width: 100vw;
  height: 65px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px;
  text-align: left;
  z-index: 9;
  background: $greyColorLight;
  h1 {
    margin: 0;
    line-height: 0;
    text-align: right;
    img {
      height: 25px;
      @include breakpoint(mobile) {
        height: 20px;
      }
    }
  }
}
</style>
